import React from 'react';
import {
  formatDistanceToNowStrict,
  isToday,
  isYesterday,
  format,
  differenceInHours
} from 'date-fns';
import Linkify from 'react-linkify';
import { Link } from 'react-router';

import CardOutline from '../../CardOutline';
import CharacterProfileImage from '@evdy/web-core/dist/components/shared/elements/CharacterProfileImage';
import InlineInput from '../../InlineInput';

import { nameString } from '@evdy/web-core/dist/lib/utils';

import styles from './Message.module.scss';

const {
  message: messageClass,
  'poster-profile': posterProfileClass,
  'poster-details': posterDetailsClass,
  'poster-name': posterNameClass,
  'poster-created-at': posterCreatedAtClass,
  'message-section': messageSectionClass,
  'comment-section': commentSectionClass,
  'comment-view-more': commentViewMoreClass,
  'comment-section-responses': commentSectionResponsesClass,
  comment: commentClass,
  'comment-body': commentBodyClass,
  'comment-name': commentNameClass,
  'comment-response': commentResponseClass,
  'comment-input': commentInputClass,
  'comment-input-overlay': commentInputOverlayClass
} = styles;

const maxVisibleComments = 1;

const formatTimestamp = date => {
  if (differenceInHours(Date.now(), date) === 0) return 'Less than an hour ago';
  if (isToday(date)) return formatDistanceToNowStrict(date, { addSuffix: true });
  if (isYesterday(date)) return `Yesterday at ${format(date, "h:mmaaaaa'm'")}`;
  return `${format(date, 'MMM d, yyyy')} at ${format(date, "h:mmaaaaa'm'")}`;
};

const Message = props => {
  const {
    poster,
    posterImage,
    createdAt,
    message,
    comments,
    displayMode = false,
    messageDetailUrl = ''
  } = props;
  const visibleComments = displayMode ? comments.slice(0, maxVisibleComments) : comments;
  const renderViewMore = comments?.length > maxVisibleComments;
  const inputPlaceholder = 'Write your message here...';

  return (
    <div className={messageClass}>
      <CardOutline>
        <div className={posterProfileClass}>
          <CharacterProfileImage name={poster?.name} image={posterImage} />
          <div className={posterDetailsClass}>
            <div className={posterNameClass}>{nameString(poster?.name)}</div>
            {/* createdAt errors out when you log out before redirect */}
            {createdAt && <div className={posterCreatedAtClass}>{formatTimestamp(createdAt)}</div>}
          </div>
        </div>
        <div className={messageSectionClass}>
          {message &&
            message.split('\n').map((s, idx) => (
              <p key={idx}>
                <Linkify properties={{ target: '_blank', rel: 'noreferrer noopener' }}>{s}</Linkify>
              </p>
            ))}
        </div>
        {!!comments?.length && (
          <div className={commentSectionClass}>
            {renderViewMore && displayMode && (
              <Link to={messageDetailUrl} className={commentViewMoreClass}>
                View all responses
              </Link>
            )}
            <div className={commentSectionResponsesClass}>
              {visibleComments.map(({ _id, poster, message }) => (
                <div key={_id} className={commentClass}>
                  <CharacterProfileImage name={poster?.name} image={poster?.image} />
                  <div className={commentBodyClass}>
                    <div className={commentNameClass}>{nameString(poster?.name)}</div>
                    <div className={commentResponseClass}>
                      {message &&
                        message.split('\n').map((s, idx) => (
                          <p key={idx}>
                            <Linkify properties={{ target: '_blank', rel: 'noreferrer noopener' }}>
                              {s}
                            </Linkify>
                          </p>
                        ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {displayMode && (
          <Link to={messageDetailUrl} className={commentInputClass}>
            <div className={commentInputOverlayClass}>
              <InlineInput placeholder={inputPlaceholder} submitBtnCopy="Reply" />
            </div>
          </Link>
        )}
      </CardOutline>
    </div>
  );
};

export default Message;
